<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                Bán hàng
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)

const headers = [
  {
    field: 'name',
    headerName: $t('labels.staffSale')
  },
  {
    field: 'totalOpportunity',
    headerName: $t('labels.businessOpportunityCount'),
    valueGetter: (params: any) => {
      const { totalOpportunity } = params.data
      return $formatters.formatNumber(totalOpportunity || 0)
    }
  },
  {
    field: 'totalQuote',
    headerName: $t('labels.quoteCount'),
    valueGetter: (params: any) => {
      const { totalQuote } = params.data
      return $formatters.formatNumber(totalQuote || 0)
    }
  },
  {
    field: 'totalOrder',
    headerName: $t('labels.orderCount'),
    valueGetter: (params: any) => {
      const { totalOrder } = params.data
      return $formatters.formatNumber(totalOrder || 0)
    }
  },
  {
    field: 'totalTrip',
    headerName: $t('labels.tripCount'),
    valueGetter: (params: any) => {
      const { totalTrip } = params.data
      return $formatters.formatNumber(totalTrip || 0)
    }
  },
  {
    field: 'totalCustomerLead',
    headerName: $t('labels.leadCount'),
    valueGetter: (params: any) => {
      const { totalCustomerLead } = params.data
      return $formatters.formatNumber(totalCustomerLead || 0)
    }
  },
  {
    field: 'totalCustomerProspect',
    headerName: $t('labels.prospectCount'),
    valueGetter: (params: any) => {
      const { totalCustomerProspect } = params.data
      return `${$formatters.formatNumber(totalCustomerProspect || 0)}`
    }
  },
  {
    field: 'totalCustomerOpportunity',
    headerName: $t('labels.oppotunityCount'),
    valueGetter: (params: any) => {
      const { totalCustomerOpportunity } = params.data
      return `${$formatters.formatNumber(totalCustomerOpportunity || 0)}`
    }
  },
  {
    field: 'totalCustomer',
    headerName: $t('labels.customerCount'),
    valueGetter: (params: any) => {
      const { totalCustomer } = params.data
      return `${$formatters.formatNumber(totalCustomer || 0)}`
    }
  },

  {
    field: 'revenue',
    headerName: $t('labels.revenue'),
    valueGetter: (params: any) => {
      const { revenue } = params.data
      return `${$formatters.formatNumber(revenue || 0)}`
    }
  },
  {
    field: 'cost',
    headerName: $t('labels.cost'),
    valueGetter: (params: any) => {
      const { cost } = params.data
      return `${$formatters.formatNumber(cost || 0)}`
    }
  },
  {
    field: 'profit',
    headerName: $t('labels.profit'),
    valueGetter: (params: any) => {
      const { profit } = params.data
      return `${$formatters.formatNumber(profit || 0)}`
    }
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getSale, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
